import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import languageIcon from '../../../assets/language.svg';
import styles from './LanguageSwitcher.module.css';

const LanguageSwitcher = () => {
    const { i18n, t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
    };

    const languages = [
        { code: 'fi', label: t('language.fi') },
        { code: 'fi-tampere', label: t('language.fi-tampere') },
        { code: 'en', label: t('language.en') }
    ];

    return (
        <div className={styles.LanguageSwitcher}>
            <button
                className={styles.LanguageBtn}
                onClick={() => setIsOpen(!isOpen)}
                title={t('language.select')}
                type="button"
            >
                <img src={languageIcon} alt="Language" />
            </button>

            {isOpen && (
                <div className={styles.LanguageMenu}>
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            className={i18n.language === lang.code ? styles.Active : ''}
                            onClick={() => changeLanguage(lang.code)}
                        >
                            {lang.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
